import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import {BASE} from '../api/api'
import Axios from 'axios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { Link } from 'react-router-dom'

class Content extends Component {
    constructor(props) {
        super(props);
        this.state={
            page:0,
            next:false,
            prev:false,
            id:props.match.params.id,
            title:props.match.params.title,
            type:props.match.params.type,

        }
    
      }

    topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    //setting the link to address
    goto2(title,nid,name) {
        let login = localStorage.getItem('token');
        if (login && login != null) {

        if(name!=undefined)     
            if (name==='18') {
                    return '/theses_desc/'+nid
                }
                else if (name==='16') {
                    return '/book_desc/'+nid
                }
                else if (name==='19') {
                    return '/conf_desc/'+nid
                }
                else if (name==='17') {
                    return '/book_chap_desc/'+nid
                }
                else if (name==='15') {
                    return '/article_desc/'+nid
                }
 
        }
        else {
            if (name==='18') {
                let redir=['/theses_desc/'+nid]
                localStorage.setItem('redir',redir)
                return '/login?redir='+'/theses_desc/'+nid
            }
            else if (name==='16') {
                let redir=['/book_desc/'+nid]
                localStorage.setItem('redir',redir)
                return '/login?redir='+'/book_desc/'+nid
            }
            else if (name==='19') {
                let redir=['/conf_desc/'+nid]
                localStorage.setItem('redir',redir)
                return '/login?redir='+'/conf_desc/'+nid
            }
            else if (name==='17') {
                let redir=['/book_chap_desc/'+nid]
                localStorage.setItem('redir',redir)
                return '/login?redir='+'/book_chap_desc/'+nid
            }
            else if (name==='15') {
                let redir=['/article_desc/'+nid]
                localStorage.setItem('redir',redir)
                return '/login?redir='+'/article_desc/'+nid
            }         
        }
    }

    checkpage(id,nextpage,type){
        this.setState({
            next: false
        })
            Axios(BASE+'api/'+type+'/'+id+'?page='+nextpage, {

            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
            })
            .then((data) => {
                console.log('next',data)
                if(data.data.constructor === Array)
                    if (data.data.length === 0) {
                        this.setState({
                            next: false
                        })
                    }
                    else{
                        this.setState({
                            next: true
                        })
                    }
                else{
                    this.setState({
                        next: false
                    })
                }
        
            })
            .catch((err) => {
                console.log('not found')
            })
            
            
    }

    handlePageClick = data => {
        if (data === 'next' && this.state.next === true) {
                this.setState({
                    related: '',
                })
                this.apicall(this.state.id,this.state.page + 1,this.state.type)
                this.setState({
                    page: this.state.page + 1
                })
            

        }
        else if (data === 'prev' && this.state.prev === true) {
            this.setState({
                related: '',
            })
            this.setState({
                page: this.state.page - 1
            })
            this.apicall(this.state.id,this.state.page - 1,this.state.type)
        }


    };

    apicall(id,p,type){
        if(p<=0){
            this.setState({
                prev:false
            })
        }
        else{
            this.setState({
                prev:true
            })
        }
        Axios(BASE+'api/'+type+'/'+id+'?page='+p, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        .then((data) => {
            console.log(data,'tax')
            this.checkpage(id,p+1,type)
            this.setState({
                related:data.data
            })
            this.topFunction()

        })
        .catch((err) => {
            console.log('not found')
        })
    }


    componentWillMount(){
        this.topFunction();

        //Taxonomy related
        this.apicall(this.state.id,0,this.state.type)
    }



render() {
    
    return (
        <div className='taxpage formrea yourwork sub_work'>
                    <Header />

                    <div className="listing">


                        <div className="page-title">
                            <div className="title-wrapper">
                                <div className="container gloss_container">
                                        <div>
                                            <h1 className="heading">{this.state.title}</h1>
                                        </div>
                                </div>
                            
                            </div>
                        </div>

                        <div className="main-content">
                            <div className="container">
                                <div className="row">
                                    <div className="region region-content">
                                        <div className="listings">
                                        {this.state.related ?
                                        <div className="mission">
                                            {this.state.related?this.state.related.length? this.state.related.map((related, index) => {
                                                return (
                                                    <div>
                                                        <div className="title">
                                                            <span className="field-content">
                                                                <Link to={this.goto2(related.title[0].value,related.nid[0].value,related.field_select_work_to_submit[0].target_id)}>
                                                                {related.title[0].value}
                                                                </Link>
                                                            </span>
                                                        </div>

                                                    </div>
                                                )
                                            }):"":''}
                                            
                                        </div> : ''

                                    }


                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.related && (this.state.prev || this.state.next) ?

                        <ul className="pagination">
                            <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
                                <a style={{ color: this.state.prev ? '#165E84' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                            <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                        </ul>

                        : ''}
                    
                    <Footer />
                </div>
      
            )
    
    
}

}


export default Content;
